'use client'

import { cx } from 'classix'
import { Channel } from 'types/masterData'
import { usePricesStore } from '../../../context/PricesProvider'
import styles from './DiscountRateWrapper.module.css'

interface DiscountRateWrapperProps {
	readonly shouldShowDiscount: boolean
	readonly children: React.ReactNode
}

export const DiscountRateWrapper = ({
	shouldShowDiscount,
	children,
}: DiscountRateWrapperProps) => {
	const { showDiscountRate = true, channel } = usePricesStore()
	const hasDiscount = Boolean(shouldShowDiscount) && showDiscountRate

	if (!hasDiscount) {
		return null
	}

	return (
		<div
			className={cx(
				styles.discountRateContainer,
				channel === Channel.Outlet && styles.hightlightedDiscount
			)}
		>
			{children}
		</div>
	)
}
